export const GET_SOFTWARES = "SOFTWARES.GET";
export const GET_API_UPLOADS = "GET_API_UPLOADS";
export const GET_API_DATE_UPLOADS = "GET_API_DATE_UPLOADS"